import React, { useState } from 'react';
import { bool, func, object, string } from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { ensureOwnListing } from '../../util/data';
import { findOptionsForSelectFilter } from '../../util/search';
import { LISTING_STATE_DRAFT } from '../../util/types';
import { ListingLink } from '../../components';
import { EditListingDescriptionForm } from '../../forms';
import config from '../../config';
import { EditorState, ContentState } from 'draft-js';

import css from './EditListingDescriptionPanel.module.css';
import BackToAdmin from '../BackToAdminButton/BackToAdminButton';

let htmlToDraft = null;
typeof window !== 'undefined'
  ? import('html-to-draftjs').then(h => {
      htmlToDraft = h.default;
    })
  : null;

const EditListingDescriptionPanel = props => {
  const {
    className,
    rootClassName,
    listing,
    disabled,
    ready,
    onSubmit,
    onChange,
    submitButtonText,
    panelUpdated,
    updateInProgress,
    errors,
    isNewURI,
    intl,
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const currentListing = ensureOwnListing(listing);
  const { description, title, publicData } = currentListing.attributes;

  const isPublished = currentListing.id && currentListing.attributes.state !== LISTING_STATE_DRAFT;
  const panelTitle = isPublished ? (
    <FormattedMessage
      id="EditListingDescriptionPanel.title"
      values={{ listingTitle: <ListingLink listing={listing} /> }}
    />
  ) : (
    <FormattedMessage id="EditListingDescriptionPanel.createListingTitle" />
  );

  const categoryOptions = findOptionsForSelectFilter('category', config.custom.filters);
  const tags = findOptionsForSelectFilter('tags', config.custom.filters);
  const tagsWithTranslations = tags.map(t => {
    return { ...t, label: intl.formatMessage({ id: t.label }) };
  });
  const contentBlock = description ? htmlToDraft(description) : null;
  const [editorState, setEditorState] = useState(
    isNewURI || !description
      ? EditorState.createEmpty()
      : EditorState.createWithContent(
          ContentState.createFromBlockArray(contentBlock?.contentBlocks)
        )
  );
  const [isValidDescription, setIsValidDescription] = useState(true);
  return (
    <div className={classes}>
      <BackToAdmin />
      <h1 className={css.title}>{panelTitle}</h1>
      <EditListingDescriptionForm
        className={css.form}
        initialValues={{ title, description, category: publicData.category, tags: publicData.tags }}
        saveActionMsg={submitButtonText}
        onSubmit={values => {
          const { title, description, category, tags } = values;
          const updateValues = {
            title: title.trim(),
            description,
            publicData: { category, tags },
          };
          onSubmit(updateValues);
        }}
        onChange={onChange}
        disabled={disabled}
        ready={ready}
        updated={panelUpdated}
        updateInProgress={updateInProgress}
        fetchErrors={errors}
        categories={categoryOptions}
        tags={tagsWithTranslations}
        editorState={editorState}
        setEditorState={setEditorState}
        isValidDescription={isValidDescription}
        setIsValidDescription={setIsValidDescription}
      />
    </div>
  );
};

EditListingDescriptionPanel.defaultProps = {
  className: null,
  rootClassName: null,
  errors: null,
  listing: null,
};

EditListingDescriptionPanel.propTypes = {
  className: string,
  rootClassName: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  disabled: bool.isRequired,
  ready: bool.isRequired,
  onSubmit: func.isRequired,
  onChange: func.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
};

export default EditListingDescriptionPanel;
